import type { ReactNode } from "react";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import { Link, useLocation } from "react-router-dom";

export function ModuleOfferWorkspace({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  const location = useLocation();
  const current = location.pathname.startsWith("/commercial/agreements") ? "agreements"
    : location.pathname.startsWith("/commercial/readiness") ? "readiness" : "offers";
  return (
    <Stack spacing={2.5} sx={{ px: { xs: 2, lg: 3 }, pb: 4, width: "100%", maxWidth: 1200, mx: "auto" }}>
      <Typography component="h1" variant="h4" sx={{ fontWeight: 700, letterSpacing: "-0.02em" }}>
        {title}
      </Typography>
      <Tabs component="nav" aria-label="Module billing sections" value={current}
        variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile
        sx={{ borderBottom: 1, borderColor: "divider", "& .MuiTab-root": {
          minWidth: 0, px: 2, fontSize: "0.8125rem", fontWeight: 700, textTransform: "none",
        } }}>
        <Tab value="offers" label="Module offers" component={Link} to="/commercial/offers" />
        <Tab value="agreements" label="Accepted offers" component={Link} to="/commercial/agreements" />
        <Tab value="readiness" label="Readiness" component={Link} to="/commercial/readiness" />
      </Tabs>
      {children}
    </Stack>
  );
}

export function ModuleOfferReadError({ onRetry }: { onRetry: () => void }) {
  return (
    <Alert severity="warning">
      Module information unavailable.{" "}
      <Button size="small" onClick={onRetry}>
        Retry
      </Button>
    </Alert>
  );
}

export function ModuleOfferPageControls({
  page,
  onOffset,
}: {
  page: { total: number; limit: number; offset: number };
  onOffset: (offset: number) => void;
}) {
  if (page.offset === 0 && page.total <= page.limit) return null;
  return (
    <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
      <Typography variant="body2">{page.total} total records</Typography>
      <Button
        size="small"
        disabled={page.offset === 0}
        onClick={() => onOffset(Math.max(0, page.offset - page.limit))}
      >
        Previous
      </Button>
      <Button
        size="small"
        disabled={page.offset + page.limit >= page.total}
        onClick={() => onOffset(page.offset + page.limit)}
      >
        Next
      </Button>
    </Stack>
  );
}
